import mutations from './mutations'
import actions from './actions'
import getters from './getters'
const state = {
  greetings: localStorage.getItem('funnies') && JSON.parse(localStorage.getItem('funnies'))  || [],
};

const module = {
  state,
  getters,
  mutations,
  actions
};

export default module;



// WEBPACK FOOTER //
// ./src/store/modules/funnies/index.js